import { render, staticRenderFns } from "./lrNoDataTable.vue?vue&type=template&id=713ec28b&scoped=true"
import script from "./lrNoDataTable.vue?vue&type=script&lang=js"
export * from "./lrNoDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713ec28b",
  null
  
)

export default component.exports